import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PageWrapper } from "../../pageWrapper/PageWrapper";
import {
  faChevronLeft,
  faChevronRight,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { Box, CircularProgress, Grid, useMediaQuery } from "@mui/material";
import { VeButton } from "../../Button/button";
import { VeTypography } from "../../../mui";
import CompletedImg from "./CompletedImg";
import React from "react";
import QuestionImg from "./QuestionImg";

const OnboardingLayout = ({
  steps,
  BasicDetails,
  Documents,
  ApplicationForm,
  Volume,
  selectedTab,
  setSelectedTab,
  discardOnClick,
  saveOnCLick,
  submitOnClick,
  onClose,
  isLoading,
  disableBtn,
  nextOnClickHandler,
  prevOnClickHandler,
  isSubmitLoading,
  isPending,
  tabSwitch,
  openHelpModal,
  variables,
}: {
  steps: any;
  BasicDetails: React.ReactNode;
  Documents: React.ReactNode;
  ApplicationForm: React.ReactNode;
  Volume: React.ReactNode;
  selectedTab: number;
  setSelectedTab: any;
  discardOnClick: any;
  saveOnCLick: any;
  submitOnClick: any;
  onClose: any;
  isLoading: any;
  disableBtn: any;
  nextOnClickHandler: any;
  prevOnClickHandler: any;
  isSubmitLoading: any;
  isPending?: any;
  tabSwitch?: any;
  openHelpModal?: any;
  variables?: any;
}) => {
  const isTab = useMediaQuery("(max-width:1200px)");
  const isMobileLg = useMediaQuery("(max-width:600px)");
  const isMobile = useMediaQuery("(max-width:420px)");
  const isLarge = useMediaQuery("(max-width:1600px)");
  const components = [BasicDetails, Documents, ApplicationForm, Volume];
  return (
    <PageWrapper style={{ paddingTop: "0px !important" }}>
      <>
        <Box
          width={"100%"}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          position={"sticky"}
          top={"0px !important"}
          zIndex={100}
          bgcolor={"white"}
          paddingTop={"24px"}
          paddingBottom={"8px"}
          flexWrap={"wrap"}
          gap={"16px"}
          flexDirection={isMobileLg ? "column" : "row"}
        >
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            width={isMobileLg ? "100%" : "auto"}
          >
            <Box
              sx={{ cursor: "pointer" }}
              onClick={() => {
                if (variables?.fromProjects && variables?.projectRefetch)
                  variables?.projectRefetch();
                onClose();
              }}
            >
              <FontAwesomeIcon
                size="lg"
                height="20px"
                icon={faTimes}
                color="#5F6368"
              />
            </Box>
            {isMobileLg && (
              <Box
                display={"flex"}
                alignItems={"center"}
                gap={"2px"}
                onClick={openHelpModal}
                sx={{ cursor: "pointer" }}
              >
                <QuestionImg />
                <VeTypography variant="label3StrongBrand">Help</VeTypography>
              </Box>
            )}
          </Box>
          {!isPending && (
            <Box
              display={"flex"}
              gap={"16px"}
              flexWrap={selectedTab === 1 ? "nowrap" : "wrap"}
              width={isMobileLg ? "100%" : "auto"}
              justifyContent={"flex-end"}
            >
              {isTab && !isMobileLg && (
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  gap={"2px"}
                  onClick={openHelpModal}
                  sx={{ cursor: "pointer" }}
                >
                  <QuestionImg />
                  <VeTypography variant="label3StrongBrand">Help</VeTypography>
                </Box>
              )}
              {selectedTab !== 0 && (
                <Box width={isMobileLg && selectedTab === 1 ? "100%" : "auto"}>
                  <VeButton
                    buttonVariant="outlined"
                    size="small"
                    fullWidth={isMobile && selectedTab === 1}
                    buttonClick={() => {
                      if (selectedTab === 1) setSelectedTab(selectedTab - 1);
                      else prevOnClickHandler();
                    }}
                    disabled={disableBtn?.prev}
                  >
                    <FontAwesomeIcon
                      style={{
                        fontSize: "8px !important",
                        marginRight: "10px",
                      }}
                      icon={faChevronLeft}
                    />
                    Previous
                  </VeButton>
                </Box>
              )}
              {selectedTab !== 3 && (
                <Box
                  width={
                    isMobile && selectedTab === 0
                      ? "148px"
                      : isMobile && selectedTab === 1
                        ? "100%"
                        : "auto"
                  }
                >
                  <VeButton
                    buttonVariant="outlined"
                    size="small"
                    fullWidth={
                      isMobile && (selectedTab === 0 || selectedTab === 1)
                    }
                    disabled={disableBtn?.next}
                    loading={selectedTab === 0 && isLoading}
                    buttonClick={() => {
                      // setSelectedTab(selectedTab + 1);
                      if (selectedTab === 0) {
                        saveOnCLick();
                        return;
                      }
                      if (selectedTab === 1) {
                        setSelectedTab(2);
                        return;
                      } else nextOnClickHandler();
                    }}
                  >
                    Next
                    <FontAwesomeIcon
                      style={{ fontSize: "8px !important", marginLeft: "10px" }}
                      icon={faChevronRight}
                    />
                  </VeButton>
                </Box>
              )}
              {(selectedTab === 2 || selectedTab === 3) && (
                <VeButton
                  buttonVariant="outlined"
                  size="small"
                  disabled={disableBtn?.discard}
                  buttonClick={discardOnClick}
                >
                  Discard Changes
                </VeButton>
              )}
              {(selectedTab === 2 || selectedTab === 3) && (
                <VeButton
                  buttonVariant="contained"
                  size="small"
                  buttonClick={saveOnCLick}
                  disabled={disableBtn?.save}
                  loading={isLoading}
                >
                  Save
                </VeButton>
              )}
              {selectedTab === 3 && (
                <VeButton
                  buttonVariant="contained"
                  size="small"
                  disabled={disableBtn?.submit}
                  buttonClick={submitOnClick}
                  loading={isSubmitLoading}
                >
                  Submit
                </VeButton>
              )}
            </Box>
          )}
        </Box>
        {isPending ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"95vh"}
          >
            <CircularProgress
              sx={{
                color: "var(--vc-violet)",
              }}
            />
          </Box>
        ) : (
          <Grid container rowGap={"32px"} paddingTop={"16px"}>
            <Grid
              item
              xs={12}
              lg={3}
              xl={2}
              borderRight={isTab ? "none" : "1px solid #E8E8E8"}
              height={isTab ? "auto" : "85vh"}
              position={"sticky"}
              zIndex={100}
              bgcolor={"white"}
              top={
                isMobileLg
                  ? selectedTab === 0 || selectedTab === 1
                    ? "104px"
                    : isMobile
                      ? "155px"
                      : "104px"
                  : isTab
                    ? "68px"
                    : "84px"
              }
              paddingBottom={isTab ? "10px" : "0"}
            >
              <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-between"}
                height={"100%"}
              >
                <Box display={"flex"} flexDirection={"column"} gap={"32px"}>
                  {!isTab && (
                    <VeTypography variant="subtitle2StrongerMain">
                      Onboarding Steps
                    </VeTypography>
                  )}
                  <Box
                    display={"flex"}
                    flexDirection={isTab ? "row" : "column"}
                    justifyContent={isTab ? "center" : ""}
                  >
                    {steps?.map((step: any, index: number) => (
                      <Box
                        display={"flex"}
                        flexDirection={isTab ? "row" : "column"}
                        height={isTab ? "auto" : "92px"}
                        width={
                          isTab && index + 1 !== steps?.length ? "86px" : "auto"
                        }
                        alignItems={isTab ? "center" : ""}
                        paddingRight={isTab ? "0" : "20px"}
                      >
                        <Box
                          display={"flex"}
                          gap={"16px"}
                          padding={"4px"}
                          alignItems={"center"}
                          borderRadius={"4px"}
                          // width={"fit-content"}
                          sx={{
                            cursor: "pointer",
                            "&:hover": {
                              backgroundColor: "#F7F7F7",
                            },
                          }}
                          onClick={() => tabSwitch(index)}
                        >
                          {step?.status === "COMPLETED" ? (
                            <CompletedImg />
                          ) : (
                            <Box
                              width="26px"
                              height={"26px"}
                              borderRadius={"100%"}
                              bgcolor={
                                step.status === "IN_PROGRESS" ? "var(--vc-violet)" : ""
                              }
                              border={
                                step.status === "NOT_STARTED"
                                  ? "1px solid #E8E8E8"
                                  : ""
                              }
                              display={"flex"}
                              justifyContent={"center"}
                              alignItems={"center"}
                            >
                              <VeTypography
                                variant={
                                  step.status === "IN_PROGRESS"
                                    ? "label2StrongMain"
                                    : "label2StrongSecondary"
                                }
                                sx={{
                                  ...(step.status === "IN_PROGRESS"
                                    ? { color: "white !important" }
                                    : {}),
                                }}
                              >
                                {index + 1}
                              </VeTypography>
                            </Box>
                          )}
                          {!isTab && (
                            <Box
                              display={"flex"}
                              flexDirection={"column"}
                              gap={"2px"}
                            >
                              <VeTypography
                                variant={
                                  step.status === "IN_PROGRESS"
                                    ? "label2StrongerBrand"
                                    : "label2StrongSecondary"
                                }
                              >
                                {step?.label}
                              </VeTypography>
                              <VeTypography variant="label4Tertiary">
                                {step?.subText}
                              </VeTypography>
                            </Box>
                          )}
                        </Box>
                        {index + 1 < steps?.length && (
                          <Box
                            height={isTab ? "2px" : "100%"}
                            width={isTab ? "100%" : "2px"}
                            paddingY={"2px"}
                            paddingX={"4px"}
                          >
                            <Box
                              height={isTab ? "2px" : "100%"}
                              width={isTab ? "100%" : "2px"}
                              bgcolor={"#E8E8E8"}
                              marginLeft={isTab ? "none" : "12px"}
                            />
                          </Box>
                        )}
                      </Box>
                    ))}
                  </Box>
                </Box>
                {!isTab && (
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    gap={"2px"}
                    onClick={openHelpModal}
                    sx={{ cursor: "pointer" }}
                  >
                    <QuestionImg />
                    <VeTypography variant="label3StrongBrand">
                      Help
                    </VeTypography>
                  </Box>
                )}
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              lg={9}
              xl={10}
              paddingLeft={isTab ? "" : isLarge ? "88px" : "128px"}
              height={"85vh"}
              overflow={"auto"}
              className="noScrollBarCustom"
              id="scroll-area"
              paddingBottom={isMobileLg ? "160px" : "0px"}
            >
              <Grid
                item
                xs={12}
                lg={9}
                xl={7}
                paddingX={isMobileLg ? "0" : isTab ? "64px" : "0"}
              >
                {components?.[selectedTab]}
              </Grid>
              <Grid xl={5} />
            </Grid>
          </Grid>
        )}
      </>
    </PageWrapper>
  );
};

export default OnboardingLayout;
